import React, { useRef, useState } from "react";
import { Form, Label, Input, Alert } from "reactstrap";
import Buttons from "../Buttons";
import eye from "../../../../../images/icons/eye.svg";
import eyeNot from "../../../../../images/icons/eye-not.svg";
import AgentSelect from "../AgentSelect";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const EYE_ICONS = {
  true: eye,
  false: eyeNot,
};
const WelcomeBackForm = ({ onLogin, showAgents, sendMagicLink, onClose }) => {
  const passwordRef = useRef();
  const error = useSelector((state) => state.session.error);
  const [passwordShown, setPasswordShown] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const eyeIcon = EYE_ICONS[passwordShown];

  useEffect(() => {
    setErrorMessage(error ? "Incorrect password." : null);
  }, [error]);

  const focusPassword = () => {
    try {
      const passwordLength = passwordRef.current?.value?.length ?? 0;
      passwordRef.current?.focus();
      setTimeout(() => {
        passwordRef.current?.setSelectionRange(passwordLength, passwordLength);
      }, 1);
    } catch (_) {}
  };


  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
    focusPassword();
  };

  const handleSubmit = () => {
    setErrorMessage(null);
    onLogin({
      password: passwordRef.current.value,
    });
  };

  return (
    <>
      {showAgents && <AgentSelect details={false} />}
      <Form className="dyna-form login-form">
        <Label for="password" className="login-form-label required">
          Password:
        </Label>
        <Input
          innerRef={passwordRef}
          className="mg-btm-10"
          type={passwordShown ? "text" : "password"}
          name="password"
          id="password"
          placeholder="Enter your password"
        />
        {error && (
          <Alert color="danger" className="mg-top-13">
            {errorMessage}
          </Alert>
        )}
        <img
          className="eye-icon"
          onClick={togglePasswordVisibility}
          src={eyeIcon}
          alt="Toggle password visibility"
        ></img>
        <a
          className="login-forgotpass"
          href={process.env.REACT_APP_AgentURI + "/emailPassword.jsp"}
        >
          Forgot Password
        </a>
      </Form>
      <Buttons
        onClose={onClose}
        type={"WelcomeBackForm"}
        onSubmit={handleSubmit}
        sendMagicLink={sendMagicLink}
      />
    </>
  );
};

export default WelcomeBackForm;
